import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles!.orderDateTitle!.css = css`
    @media print {
        font-size: 12px;
    }
    margin-bottom: 5px;
    color: #363636;
`;

savedOrderDetailsOrderInformationStyles!.shippingAddressTitle!.css = css`
    @media print {
        font-size: 12px;
    }
    margin-bottom: 5px;
    color: #363636;
`;

savedOrderDetailsOrderInformationStyles!.billingAddressTitle!.css = css`
    @media print {
        font-size: 12px;
    }
    margin-bottom: 5px;
    color: #363636;
`;
